// ── IMAGE SLOTS (Riding Instructor Ready) ────────────────────────────
// Hosted in the Impultienda store resources (Recursos).
const STORE = 'b8cae476-472a-45f2-ba9b-ef3298844341';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Gamma Studio cover plus
 * real pages 8 and 9 on the iMac, and own photos with the bonus titles typed in. Pure white background.
 */
const IMAC = RES + '1792765722524_rid-mockup-imac-d85c72d7.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the Gamma Studio book (9:16), same order as lookInside.captions: p.11, 12, 23, 32, 35, 37
 *  (pages checked clean in QC on 23/10; the year plan pages and several arena diagrams have errors, so they are not shown). */
export const pageImages: string[] = [
  RES + '1792765752530_rid-pagina-11-clase-02-plan-a05a4995.webp',
  RES + '1792765756897_rid-pagina-12-clase-02-teach-4971dea7.webp',
  RES + '1792765761445_rid-pagina-23-clase-06-58622770.webp',
  RES + '1792765765970_rid-pagina-32-clase-09-3b565f2e.webp',
  RES + '1792765770658_rid-pagina-35-clase-10-cdc47673.webp',
  RES + '1792765774704_rid-pagina-37-level-check-08fbc0c6.webp',
];
/** 5 bonus covers (titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792765727533_rid-bono-1-pista-cf77b4f7.webp',
  RES + '1792765732046_rid-bono-2-lluvia-bc5b7b02.webp',
  RES + '1792765735609_rid-bono-3-nivel-07ed15e6.webp',
  RES + '1792765739577_rid-bono-4-padres-24fba5e2.webp',
  RES + '1792765743430_rid-bono-5-juegos-34a39675.webp',
];
